import { render } from "./DeliveryModal.vue?vue&type=template&id=221f3cc1"
import script from "./DeliveryModal.vue?vue&type=script&lang=js"
export * from "./DeliveryModal.vue?vue&type=script&lang=js"

import "./DeliveryModal.vue?vue&type=style&index=0&id=221f3cc1&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__